import './style.css';

import React from 'react';

import { tw } from '../../utils/tailwind';
import { Box } from '../Core';

interface ISectionContainerProps {
  backgroundStyle?: object;
  id?: string;
  style?: React.CSSProperties;
}

const SectionContainer: FCWithClassName<ISectionContainerProps> = (props) => {
  return (
    <Box
      className={tw('section-container relative w-full py-4', props.className)}
      id={props.id}
      style={props.style}
    >
      {props.children}
    </Box>
  );
};

export default SectionContainer;
